import {
  Checkbox
} from "./chunk-N54JDBBI.mjs";

// src/multiselect/src/components/common/checkmark.tsx
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var Checkmark = ({ selected }) => {
  const checkmark = cx(
    "mr-2 flex size-6 flex-none items-center overflow-hidden rounded border border-surface-dark",
    {
      "bg-surface-dark text-surface-light": selected
    }
  );
  return /* @__PURE__ */ jsx("span", { className: checkmark, children: selected ? /* @__PURE__ */ jsx(Checkbox, {}) : null });
};

export {
  Checkmark
};
